(() => {
  const selector = '[data-otk-wholesale-section]';

  const initializeWholesale = (section) => {
    if (!(section instanceof HTMLElement) || section.dataset.otkWholesaleReady === 'true') return;
    section.dataset.otkWholesaleReady = 'true';

    section.querySelectorAll('[data-otk-wholesale-scroll]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const targetId = link.getAttribute('href');
        const target = targetId ? document.querySelector(targetId) : null;
        if (!(target instanceof HTMLElement)) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    section.querySelectorAll('[data-otk-wholesale-faq] details').forEach((item) => {
      item.addEventListener('toggle', () => {
        const summary = item.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', String(item.open));
        if (!item.open) return;

        section.querySelectorAll('[data-otk-wholesale-faq] details[open]').forEach((otherItem) => {
          if (otherItem !== item) {
            otherItem.open = false;
            const otherSummary = otherItem.querySelector('summary');
            if (otherSummary) otherSummary.setAttribute('aria-expanded', 'false');
          }
        });
      });
    });
  };

  const initializeAll = (root = document) => root.querySelectorAll(selector).forEach(initializeWholesale);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
